import React from 'react';

const Loader = ({ label = 'Loading...', size = 'md', className = '' }) => {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : '';

  return (
    <div className={`d-flex align-items-center justify-content-center gap-2 py-4 text-muted ${className}`} role="status" aria-live="polite">
      <div className={`spinner-border ${sizeClass} text-primary`} role="status" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
};

export default Loader;
